import type { Prototype } from "../prototype-types";

export const anatolyOstapenkoPrototypes: Prototype[] = [
  {
    id: "anatoly-inventory-page-usage",
    name: "Inventory page usage",
    path: "/anatoly/inventory-page-usage",
    description:
      "What brands actually do on /brand-portal/inventory. Snapshot of 8 complete UTC days, 2026-07-29 to 2026-08-05: 9,747 brands, 22,555 visits, 203,407 events across all 32 instrumented event families. Filter by HVHP, catalog size, GMV, lost GMV and primary integration; reach and intensity are reported separately and every tile carries its own caveats. Built by Anatoly Ostapenko for CG-4352.",
    owner: "Anatoly Ostapenko",
    createdAt: "2026-08-07",
    lastUpdated: "2026-08-07",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "claude-code",
    thumbnail: "/images/thumbnails/anatoly-inventory-page-usage.png",
  },
  {
    id: "anatoly-brand-portal-messages",
    name: "Brand Portal messages",
    path: "/anatoly/brand-portal-messages",
    description:
      "Every message Brand Portal web can show a brand, by page or by kind: a static snapshot copied from production code, the rules that decide when it shows, and how many brands see it and how often. Built for the Brand Notifications Centre (P-BOAT-4295).",
    owner: "Anatoly Ostapenko",
    createdAt: "2026-10-08",
    lastUpdated: "2026-10-14",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "claude-code",
    thumbnail: "https://cdn.prerelease.faire.dev/fastly/15d43defecf4c6cb7140e3e4617e412fde86ad1dc72177f058b43f5c6be56843.png",
  },
  {
    id: "anatoly-notifications-centre-xp-messages",
    name: "Notifications Centre XP messages",
    path: "/anatoly/notifications-centre-xp-messages",
    description:
      "The new Brand Notifications Centre panel as the XP ships it, filled with static rows: one mock with the 12 rows the centre adds, one with the 58 homepage notifications it carries over. Built for the Brand Notifications Centre (P-BOAT-4295).",
    owner: "Anatoly Ostapenko",
    createdAt: "2026-10-21",
    lastUpdated: "2026-10-29",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "claude-code",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/1ee4772a00399808b13908203316dc7e4dab2a5301050ca51039acecbb88968c.png",
  },
];
